import { Reaction as React } from '@/utils/reactions';
import { createContext } from 'react';
import { Artwork, Player, Round, SessionData } from '../API';
import { Reaction } from '../components/Controls/ReactionsBar';

interface PlayerSessionState {
  state: 'initializing' | 'loading' | 'connected' | 'disconnected';

  currentRound?: Round;
  artwork: Artwork[];

  player?: Player;
  players: Player[];
  reactions: Reaction[];
  session?: SessionData;

  setupPlayer(data: { name: string; feelingBefore: number }): Promise<void>;
  updatePlayerSentiment(sentiment: number, isBefore: boolean): Promise<void>;
  updatePlayerQuestion(question: string, answer: boolean): Promise<void>;

  submitDrawing(drawing: string): Promise<void>;
  reactToArtwork(reaction: React): Promise<void>;
  getArtworkReactions(): Promise<void>;
}

export const PlayerSessionContext = createContext<PlayerSessionState>({} as PlayerSessionState);
